
export const targetTotalMillis = 1500;
export const targetUpdateEvery = 100;

export const secondsPer = (items: number): number => {
	return Math.max(
		targetTotalMillis / 1000 / items,
		0.1,
	);
};
